import React, { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import Table from "../../../core/common/dataTable/index";
import CommonSelect from "../../../core/common/commonSelect";
import EmpSuccess from "../employees/employeeSuccess";
import "../employees/index.css";
import { uploadFile } from "../../../apis/auth";
import { getAllVisitor, updateVisitorsById } from "../../../apis/visitors";
import {
  getAllNationals,
  getAllNationalsDistributor,
  getAllNationalsFinancer,
  getAllNationalsRetailer,
  getAllNationalsSuper_Distributor,
} from "../../../apis/nationals";
import Select from "react-select";
import { getAllEmployee } from "../../../apis/employees";
import { Moment } from "moment";
import CommonSearch from "../commonSearch";
import PredefinedDateRanges from "../../../core/common/datePicker";
import { formatDate } from "../../../environment";
import { SpinnerLoader, successAlert } from "../../../style/scss/utils/Alerts";

type EmployeeResponse = {
  full_name: string;
  id: any;
};

type EmployeeData = {
  value: any;
  label: any;
};

type sDResponse = {
  employees: any;
  additionalData: any;
  name: string;
  adress: string;
  type: string;
  visitor_id: string;
  email: string;
  phone_number: string;
  createdAt: string;
  status: string;
  address: string;
  id: any;
};

type sdistributorData = {
  key: number;
  EmpId: string;
  Name: string;
  Email: string;
  Phone: string;
  type: string;
  visitor_id: string;
  address: string;
  Status: string;
  id: any;
  allDetails: any;
  createdAt: string;
};

const AllVisitorsList = () => {
  const initialValues = {
    name: "",
    discription: "",
    address: "",
    email: "",
  };

  const [sDistributorData, setSdistributorData] = useState<sdistributorData[]>(
    []
  );
  const [successCreation, setSuccessCreation] = useState<boolean>(false);
  const [filteredData, setFilteredData] = useState<sdistributorData[]>([]);
  const [image, setImage] = useState<File | null>(null);
  const [imageUrl, setImageUrl] = useState<string>("");
  const [selectedOption, setSelectedOption] = useState<any>();
  const [error, setError] = useState<string>("");
  const [formData, setFormData] = useState(initialValues);
  const [selectedNatOption, setSelectedNatOption] = useState<any>();
  const [finSelectedOption, setFinSelectedOption] = useState<any>();
  const [departFin, setDepartFin] = useState<any>([]);
  const [filteredOptions, setFilteredOptions] = useState<any>([]);
  const [allEmployeeData, setEmployeeData] = useState<EmployeeData[]>([]);
  const [products, setProducts] = useState<any>();
  const [isDocUploading, setDocUploading] = useState(false);
  const { name, discription, email } = formData;

  const [state, setState] = useState<{
    start: Moment | undefined;
    end: Moment | undefined;
  }>({
    start: undefined,
    end: undefined,
  });
  const { start, end } = state;

  const allOptions = [
    { value: "national", label: "National" },
    { value: "super_distributor", label: "Super Distributor" },
    { value: "distributor", label: "Distributor" },
    { value: "financer", label: "Financer" },
    { value: "retailer", label: "Branch" },
  ];

  const natOptions = [
    { value: "super_distributor", label: "Super Distributor" },
    { value: "distributor", label: "Distributor" },
    { value: "financer", label: "Financer" },
    { value: "retailer", label: "Branch" },
  ];

  const sup_dist_options = [{ value: "distributor", label: "Distributor" }];

  const dist_options = [
    { value: "financer", label: "Financer" },
    { value: "retailer", label: "Branch" },
  ];
  const fin_options = [{ value: "retailer", label: "Branch" }];

  const filterdOption = (data: any) => {
    switch (data) {
      case "master":
        setFilteredOptions(allOptions);
        break;
      case "national":
        setFilteredOptions(natOptions);
        break;
      case "super_distributer":
        setFilteredOptions(sup_dist_options);
        break;
      case "distributer":
        setFilteredOptions(dist_options);
        break;
      case "financer":
        setFilteredOptions(fin_options);
        break;
      default:
        return;
    }
  };

  const handleNatSelect = (option: any | null) => {
    setSelectedNatOption(option || undefined);
    setSelectedOption(undefined);
    setFinSelectedOption(undefined);
    filterApiCalls(option);
  };

  const filterApiCalls = (option: any) => {
    switch (option.value) {
      case "national":
        fetchAllNationals();
        break;
      case "super_distributor":
        fetchAllSuperDistributors();
        break;
      case "distributor":
        fetchAllDistributors();
        break;
      case "financer":
        fetchAllFinancers();
        break;
      case "retailer":
        fetchAllRetailers();
        break;
      default:
        return;
    }
  };

  const fetchAllNationals = async () => {
    const data = {
      start_date: start ? start.format("MM/DD/YYYY") : undefined,
      end_date: end ? end.format("MM/DD/YYYY") : undefined,
    };
    const response = await getAllNationals(data);
    setDepartFin(
      response.data.map((ele: any) => {
        return {
          value: ele.id,
          label: ele.full_name,
        };
      })
    );
  };
  const fetchAllSuperDistributors = async () => {
    const data = {
      start_date: start ? start.format("MM/DD/YYYY") : undefined,
      end_date: end ? end.format("MM/DD/YYYY") : undefined,
    };
    const response = await getAllNationalsSuper_Distributor(data);
    const filteredData = response?.data?.superDistributorData;

    setDepartFin(
      filteredData.map((ele: any) => {
        return {
          value: ele.id,
          label: ele.full_name,
        };
      })
    );
  };
  const fetchAllDistributors = async () => {
    const data = {
      start_date: start ? start.format("MM/DD/YYYY") : undefined,
      end_date: end ? end.format("MM/DD/YYYY") : undefined,
    };
    const response = await getAllNationalsDistributor(data);
    const filteredData = response?.data?.distributorData;
    setDepartFin(
      filteredData.map((ele: any) => {
        return {
          value: ele.id,
          label: ele.full_name,
        };
      })
    );
  };

  const fetchAllFinancers = async () => {
    const data = {
      start_date: start ? start.format("MM/DD/YYYY") : undefined,
      end_date: end ? end.format("MM/DD/YYYY") : undefined,
    };
    const response = await getAllNationalsFinancer(data);
    const newResponse = response?.data?.financerAllData;
    setDepartFin(
      newResponse?.map((ele: any) => {
        return {
          value: ele.id,
          label: ele.full_name,
        };
      })
    );
  };

  const fetchAllRetailers = async () => {
    const data = {
      start_date: start ? start.format("MM/DD/YYYY") : undefined,
      end_date: end ? end.format("MM/DD/YYYY") : undefined,
    };
    const response = await getAllNationalsRetailer(data);
    const newResponse = response?.data?.retailerAllData;
    setDepartFin(
      newResponse?.map((ele: any) => {
        return {
          value: ele.id,
          label: ele.full_name,
        };
      })
    );
  };

  const handleFinSelect = (option: any | null) => {
    setFinSelectedOption(option || undefined);
    const newResponse = sDistributorData.filter((ele, i) => {
      return Number(ele.allDetails.user_id) === Number(option?.value);
    });
    setFilteredData(newResponse);
  };

  const getAllEmployees = async () => {
    try {
      const data = {
        start_date: "",
        end_date: "",
      };
      const response = await getAllEmployee(data);
      const filteredEmployees = response.data.filter(
        (employee: any, i: any) => employee.type === "visitor"
      );
      const employeeData = filteredEmployees?.map(
        (item: EmployeeResponse, i: number) => ({
          label: item.full_name ? item.full_name : "Not Assigned",
          value: item.id || "--",
        })
      );
      setEmployeeData(employeeData);
    } catch (error) {
      console.error(error, "error");
    }
  };

  const fetchAllSuperDistributor = async () => {
    try {
      const data = {
        start_date: "",
        end_date: "",
        one_time: true,
      };
      const response = await getAllVisitor(data);
      const employeeData = response?.data?.map(
        (item: sDResponse, i: number) => ({
          key: `${i + 1}`,
          createdAt: formatDate(item.createdAt),
          Name: `${item.additionalData.full_name}` || "--",
          companyName: item.additionalData.company_name,
          phoneNumber: item.additionalData.phone_number,
          address: item.address
            ? (() => {
              const parsedAddress =
                typeof item.address === "string"
                  ? JSON.parse(item.address)
                  : item.address;
              return `${parsedAddress.street || ""}, ${parsedAddress.city || ""
                }, ${parsedAddress.state || ""}, ${parsedAddress.country || ""
                }, ${parsedAddress.zip || ""}`
                .replace(/(, )+,/g, ",")
                .replace(/, $/, "");
            })()
            : "--",
          type: `${item.type}` || "--",
          Email: item.email || "--",
          visitor_id: item.visitor_id || "--",
          visitor_Name: item.employees.full_name,
          visitor_Mobile_Number: item.employees.phone_number,
          Status: item.status || "--",
          id: item.id || "--",
          allDetails: item || "--",
        })
      );
      setSdistributorData(employeeData || []);
      setFilteredData(employeeData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const handleSelect = (option: any | null) => {
    setSelectedOption(option || undefined);
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    getAllEmployees();
    fetchAllSuperDistributor();
  }, []);

  const sDistributorcolumn = [
    {
      title: "Sr No.",
      dataIndex: "key",
      render: (text: string) => (
        <div className="ms-2">
          <p className="text-dark mb-0">{text}</p>
        </div>
      ),
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      render: (text: string) => (
        <div className="ms-2">
          <p className="text-dark mb-0">{text}</p>
        </div>
      ),
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (_: any, record: sdistributorData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              {record?.allDetails?.additionalData?.full_name || "-"}
            </p>
          </div>
        </div>
      ),
      sorter: (a: sdistributorData, b: sdistributorData) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: "Company Name",
      dataIndex: "CompanyName",
      render: (_: any, record: sdistributorData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              {record?.allDetails?.additionalData?.company_name || "-"}
            </p>
          </div>
        </div>
      ),
      sorter: (a: sdistributorData, b: sdistributorData) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: "Mobile Number",
      dataIndex: "Email",
      sorter: (a: sdistributorData, b: sdistributorData) =>
        a.Email.localeCompare(b.Email),
      render: (_: any, record: sdistributorData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              {record?.allDetails?.additionalData?.phone_number || "-"}
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Visitors Name",
      dataIndex: "visitor_name",
      render: (_: any, record: sdistributorData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              {record?.allDetails?.employees?.full_name || "-"}
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Vistior Mobile Number",
      dataIndex: "Email",
      sorter: (a: sdistributorData, b: sdistributorData) =>
        a.Email.localeCompare(b.Email),
      render: (_: any, record: sdistributorData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              {record?.allDetails?.employees?.phone_number || "-"}
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (text: string) => (
        <div className="ms-2">
          <p className="text-dark mb-0">{text}</p>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: sdistributorData) => (
        <span>
          <Link
            to="#"
            className={`badge  btn btn-white ${text === "Active" ? "badge-success" : "badge-danger"
              } d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {text}
          </Link>
        </span>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_: EmployeeData, record: sdistributorData) => {
        let path = "#";
        switch (record.type) {
          case "retailer":
            path = `/viewRetailers?retailer_id=${record.visitor_id}`;
            break;
          case "financer":
            path = `/ViewFinancers?financer_id=${record.visitor_id}`;
            break;
          case "distributor":
            path = `/viewdistributor?distributor_id=${record.visitor_id}`;
            break;
          case "super-distributor":
            path = `/superdistributor?super_distributor_id=${record.visitor_id}`;
            break;
        }

        const isEmployee =
          JSON.parse(sessionStorage.getItem("info") || "{}")?.type ===
          "employee";

        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className="action-icon d-inline-flex">
              <Link to={path}>
                <i className="ti ti-eye" />
              </Link>
            </div>
            {isEmployee && (
              <div
                data-bs-toggle="modal"
                data-inert={true}
                data-bs-target="#add_employee"
                className="btn btn-primary d-flex align-items-center ms-2"
                onClick={() => handleChangeNewStatus({ data: record })}
              >
                Visits
              </div>
            )}
          </div>
        );
      },
    },
  ];

  const [geoLocation, setGeoLocation] = useState<{
    lat: number;
    lon: number;
  } | null>(null);
  const handleVisitClick = (record: any) => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        setGeoLocation({ lat: latitude, lon: longitude });
        setProducts(record);
      },
      (error) => {
        if (error.code === error.PERMISSION_DENIED) {
          alert("Please enable location access to proceed.");
        } else {
          alert("Unable to retrieve location. Please try again.");
        }
      }
    );
  };

  const handleChangeNewStatus = async (data: { data: any }) => {
    const date = new Date();
    handleVisitClick(data.data);
    const formattedDate = date.toISOString().split("T")[0];
  };
  const department = [
    { value: "Select", label: "Select" },
    { value: "All Department", label: "All Department" },
    { value: "Finance", label: "Finance" },
    { value: "Developer", label: "Developer" },
    { value: "Executive", label: "Executive" },
  ];

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        setError("Image size should be below 10 MB");
        setImage(null);
        return;
      }
      setDocUploading(true);
      setError("");
      setImage(file);
      const formData = new FormData();
      formData.append("image", file);
      const response = await uploadFile(formData);
      if (response.status === true) {
        setDocUploading(false);
        setImageUrl(response.data.image);
      }
    }
  };

  const handleCancel = () => {
    setImage(null);
    setError("");
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    if (!geoLocation) {
      alert("Please allow location access to proceed.");
      return;
    }
    if (!formData.name && !formData.discription) {
      alert("Please fill all the required fields");
    }
    const id = products?.id;
    const payload = {
      status: "done",
      description: formData.discription,
      image: imageUrl,
      email: formData.email,
      name: formData.name,
      geo_location: geoLocation,
    };
    try {
      const response = await updateVisitorsById(id, payload);
      if (response.status === true) {
        fetchAllSuperDistributor();
        setFormData(initialValues);
        setSelectedOption(undefined);
        setProducts("");
        setImage(null);
        setError("");
        setSuccessCreation(true);
        successAlert("Success", "Successfully updated");
      }
    } catch (error) { }
  };

  useEffect(() => {
    const type = sessionStorage.getItem("info");
    if (type) {
      const parsedData = JSON.parse(type);
      if (parsedData) {
        filterdOption(parsedData?.type);
      }
    }
  }, [state]);

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "pending visiting list");
    XLSX.writeFile(workbook, "Pending Visting List.xlsx");
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap "></div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto  right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <CommonSearch
                    allEmployeeData={sDistributorData}
                    setFilteredData={setFilteredData}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <label style={{ color: "#000" }}>Parent Role</label>
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#b4b4b447",
                        color: "#00000057",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      {selectedNatOption
                        ? selectedNatOption.label
                        : "Select Role"}
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {filteredOptions?.map((item) => (
                        <li key={item.value}>
                          <div
                            className="dropdown-item rounded-1"
                            onClick={() => handleNatSelect(item)}
                          >
                            {item.label}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <label style={{ color: "#000" }}>Parent User</label>
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#b4b4b447",
                        color: "#00000057",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      {finSelectedOption
                        ? finSelectedOption.label
                        : "Select User"}
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {departFin.map((item) => (
                        <li key={item.value}>
                          <div
                            className="dropdown-item rounded-1"
                            onClick={() => handleFinSelect(item)}
                          >
                            {item.label}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="input-icon-end position-relative">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <label style={{ color: "#000" }}>Date Range</label>
                    <PredefinedDateRanges state={state} setState={setState} />
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "20px 0px 0px 6rem",
                  }}
                >
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#3ab54bbf",
                        color: "#fff",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Export
                    </Link>

                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <div
                          onClick={exportToExcel}
                          className=" btn  dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="card-body p-0">
              <h3 style={{ margin: "10px" }}>All Visitors</h3>
              {filteredData && filteredData.length > 0 ? (
                <Table
                  dataSource={filteredData}
                  columns={sDistributorcolumn}
                  Selection={true}
                />
              ) : (
                <p className="custom-cal-react " style={{ padding: "15px" }}>
                  No Data Found
                </p>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="add_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Full Name
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="name"
                            required
                            value={name}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Description
                            <span className="text-danger"> *</span>
                          </label>
                          <textarea
                            // type="textArea"
                            name="discription"
                            required
                            value={discription}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Mobile Number
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="number"
                            name="email"
                            required
                            value={email}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="profile-upload">
                            <div className="mb-2">
                              <h6 className="mb-1">Upload Profile Image</h6>
                              <p className="fs-12">
                                Image should be below 10 MB
                              </p>
                              {error && <p className="text-danger">{error}</p>}
                            </div>
                            <div className="profile-uploader d-flex align-items-center">
                              {isDocUploading && (
                                <SpinnerLoader className="mr-2" />
                              )}
                              <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                Upload
                                <input
                                  type="file"
                                  required
                                  className="form-control image-sign"
                                  accept="image/*"
                                  disabled={isDocUploading}
                                  onChange={handleFileChange}
                                />
                              </div>
                              <Link
                                to="#"
                                className="btn btn-light btn-sm"
                                onClick={handleCancel}
                              >
                                Cancel
                              </Link>
                            </div>
                            {image && (
                              <div className="mt-3">
                                <p>Preview:</p>
                                <img
                                  src={URL.createObjectURL(image)}
                                  alt="Profile Preview"
                                  className="img-thumbnail"
                                  style={{
                                    maxWidth: "150px",
                                    maxHeight: "150px",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      // onClick={handleSubmit}
                      // data-bs-dismiss={"modal"}
                      disabled={isDocUploading}
                      className="btn btn-primary"
                    >
                      {isDocUploading ? <SpinnerLoader /> : "Submit"}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade" id="edit_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Edit Plans</h4>
                <span>Plans ID : EMP -0024</span>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form action={all_routes.employeeList}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab2" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab2"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info2"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent2">
                <div
                  className="tab-pane fade show active"
                  id="basic-info2"
                  role="tabpanel"
                  aria-labelledby="info-tab2"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Department</label>
                          <CommonSelect
                            className="select"
                            options={department}
                            defaultValue={department[1]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade" id="visits">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add Visitor</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab2" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab2"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info2"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent2">
                <div
                  className="tab-pane fade show active"
                  id="basic-info2"
                  role="tabpanel"
                  aria-labelledby="info-tab2"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Select Employees</label>
                          <Select
                            classNamePrefix="react-select"
                            className="select"
                            options={allEmployeeData}
                            value={selectedOption}
                            onChange={handleSelect}
                            placeholder="Select Employees"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {successCreation && <EmpSuccess all_routes={all_routes} />}
    </>
  );
};

export default AllVisitorsList;
